import { CustomerStatusEnum, CustomerStatusTypes } from "@hooks/dtos/user-dto";

export const CustomerConvertStatus = (
  status: CustomerStatusTypes,
): {
  text: string;
  description: string;
  color: string;
} => {
  switch (status) {
    case CustomerStatusEnum.ACTIVE:
      return {
        text: "Ativo",
        description: "O usuário está ativo.",
        color: "success",
      };

    case CustomerStatusEnum.INACTIVE:
      return {
        text: "Inativo",
        description: "O usuário está inativo.",
        color: "warning",
      };

    case CustomerStatusEnum.DELETED:
      return {
        text: "Deletado",
        description: "O usuário foi deletado.",
        color: "danger",
      };

    default:
      return {
        text: "Status Desconhecido",
        description: "O status informado não pôde ser identificado.",
        color: "danger",
      };
  }
};